import React from "react"
import { useSelector } from "react-redux"

import SpinnerWithSearching from "../../components/SpinnerWithSearching"
import { RootState } from "../../globalStore/rootreducer"
import { TLoginUserInfo } from "../../service/auth/TAuth"

type TCategoryOuter<T> = {
  children: React.ReactNode
  searchFunction: (userInfo: TLoginUserInfo) => Promise<T>
  searchStartFlag: boolean
}

const TopCategoryOuter = <T,>({ ...props }: TCategoryOuter<T>) => {
  const loginUserInfo = useSelector(
    (state: RootState) => state.user.LoginUserInfo
  )

  return (
    <SpinnerWithSearching
      searchFunction={props.searchFunction}
      condition={loginUserInfo}
      searchStart={props.searchStartFlag}>
      {props.children}
    </SpinnerWithSearching>
  )
}

export default TopCategoryOuter
